var map = {
	"./ecommerce-javascript.json": 763,
	"./hexa-technology.json": 543,
	"./pharmacy-medicamentos.json": 477,
	"./practica-redux.json": 218,
	"./saludsync.json": 612,
	"./topdrinks.json": 684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 817;